import { ListenedMessage, ListenedMessageHandler, ListenedMessageType } from 'native_bridge/types'
const listeners: { [messageType in ListenedMessageType]?: Function } = {}
/**
 * This is what the frontend calls when it wants to define behavior for when
 * the native app makes a call via native bridge.
 */
// export function listen (messageType: ListenedMessageType, callback: Function): void {
export function listen(messageType: ListenedMessageType, callback: Function): void {
  listeners[messageType] = callback
}

/**
 * This is what the native app will eventually call when it needs the
 * frontend to do something.
 * @returns true if found a listener to the message type, false otherwise.
 */
export function callListener(message: ListenedMessage): boolean {
  const func = listeners[message.message_type]
  if (func) {
    func(message)
    return true
  }
  return false
}

export const respondToPadletSettingsUpdate = (msgHandler: ListenedMessageHandler): void => {
  listen('padlet_settings_update', msgHandler)
}

export const respondToSettingsPanelHide = (msgHandler: ListenedMessageHandler): void => {
  listen('padlet_settings_hide', msgHandler)
}

export const respondToPostCreation = (msgHandler: ListenedMessageHandler): void => {
  listen('create_post', msgHandler)
}

export const respondToSignalToHideAllPanelsAndMenus = (msgHandler: ListenedMessageHandler): void => {
  listen('cancel_show', msgHandler)
}
